import React from "react";
import ReactDOM from "react-dom/client";

import App from "@/App";
import { consumeImpersonationHandoff } from "@/lib/auth/impersonationHandoff";
import "@/index.css";
import "@/styles/tokens.css";

// Consume the operator-impersonation handoff fragment (#impersonate=<jwt>) FIRST,
// before any render or telemetry (Sentry/PostHog) init: this seeds the in-memory
// session and immediately scrubs the token from the URL so a captured
// location.href can never leak a live bearer token. A no-op for normal sessions.
consumeImpersonationHandoff();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root not found in index.html");
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
